import React, { useState } from 'react'
import { useReactiveVar } from '@apollo/client'

import { OutletMenuSearch } from '@src/components/SiteHeader/SearchBar/OutletMenuSearch/OutletMenuSearch'
import { Capsule, CapsuleContainer } from '@src/components/Capsule'
import { breakpoints } from '@src/constants/breakpoints'
import { screenResolutionVar } from '@src/models/screenResolution'

import {
  Container,
  FilterOverlay,
  MenuCapsuleWrapper,
  OutletMenuSearchContainer,
} from './OutletMenuSection.styles'

import { OutletMenuItemGroupTree } from '../menuItemGroupTreeType'
import { useOutletPageContext } from '../OutletPageContext'
import { useCheckoutRouter } from '@src/hooks/useCheckoutRouter/useCheckoutRouter'

export const OutletMenuSection: React.FC<{
  parentMenus: Pick<
    OutletMenuItemGroupTree[number]['parentMenu'],
    'id' | 'name'
  >[]
  activeMenuId: string | null
  outletId: string
  outletDisplayName: string
  isInStackedMenuView: boolean
}> = ({ parentMenus, activeMenuId, outletId, isInStackedMenuView }) => {
  const {
    setActiveMenuId,
    setManualNavigation,
    showMenuSearchResults,
    isStackedMenu,
  } = useOutletPageContext()
  const { width } = useReactiveVar(screenResolutionVar)
  const { displayPermanentCheckout } = useCheckoutRouter()

  const [showSearchBar, setShowSearchBar] = useState(isStackedMenu)

  const handleCapsuleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    parentMenuId: string
  ) => {
    setManualNavigation(true)
    setActiveMenuId(parentMenuId)

    // Scroll the capsule into view
    event.currentTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })

    // Scroll to the menu section
    const element = document.getElementById(parentMenuId)
    if (element) {
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - 200

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  return (
    <>
      {width < breakpoints.wideDesktop && <FilterOverlay />}
      <Container $isStackedMenuView={isStackedMenu && isInStackedMenuView}>
        {!showSearchBar && !isStackedMenu && (
          <MenuCapsuleWrapper>
            <CapsuleContainer>
              {!showMenuSearchResults &&
                parentMenus.map(parentMenu => (
                  <Capsule
                    onClick={event => handleCapsuleClick(event, parentMenu.id)}
                    active={activeMenuId === parentMenu.id}
                    key={parentMenu.id}
                  >
                    {parentMenu.name}
                  </Capsule>
                ))}
            </CapsuleContainer>
          </MenuCapsuleWrapper>
        )}
        <OutletMenuSearchContainer
          $isStackedMenuView={isStackedMenu && isInStackedMenuView}
          displayPermanentCheckout={displayPermanentCheckout}
        >
          <OutletMenuSearch
            outletId={outletId}
            showSearchBar={showSearchBar}
            setShowSearchBar={setShowSearchBar}
          />
        </OutletMenuSearchContainer>
      </Container>
    </>
  )
}
